import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import CustomModal from '../Modal';
import UserStore from '../../stores/UserStore';

const images = {
    settings: require('img/icons/settings.svg'),
    settingsWhite: require('img/icons/settings-white.svg'),
};

function DataComponentTableColumns({ settingKey, data: pData = [], onApply }) {
    const [key, setKey] = useState(settingKey);
    const [data, setData] = useState(pData);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => setData(pData), [pData]);

    const t = useMemo(() => UserStore.getTranslation(), []);
    const staticNames = useMemo(() => ({
        column: t?.dataTable?.column || {},
        actions: t?.actions || {},
        reportPage: t?.reportPage || { metricsTitle: 'Metrics' },
        ...t.dataTable.column
    }), [t]);

    const onToggleModal = useCallback(() => setIsVisible(v => !v), []);
    const onToggle = useCallback((e) => {
        const idx = e.target.closest('.checkbox')?.getAttribute('data-index');
        if (idx == null) return;
        const checked = e.target.checked;
        setData(prev => {
            const next = prev.slice();
            next[idx] = { ...next[idx], visible: checked };
            return next;
        });
    }, []);
    const onApplyLocal = useCallback(() => {
        if (!key) return;
        onApply && onApply(key, data);
        onToggleModal();
    }, [key, data, onApply, onToggleModal]);

    return (
        <>
            <button id="metricsPopup" className="btn" onClick={onToggleModal}>
                <img src={images.settings} alt="" />
            </button>

            <CustomModal
                className="settingsMenu"
                title={staticNames.reportPage.metricsTitle}
                confirmName={staticNames.actions.apply}
                visible={isVisible}
                onClose={onToggleModal}
                onConfirm={onApplyLocal}
            >
                <div className="row">
                    <div className="col-xs-12">
                        <div className="dbox-body">
                            <div className="dbox-labels">
                                {data.map((item, i) => {
                                    if (item.disabled) return null;
                                    const title = item.title || item.keyTitle;
                                    return (
                                        <div className="checkbox" key={i} data-index={i}>
                                            <input
                                                id={`column-${i}`}
                                                type="checkbox"
                                                checked={!!item.visible}
                                                onChange={onToggle}
                                            />
                                            <label htmlFor={`column-${i}`}>{Parser(title)}</label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </CustomModal>
        </>
    );
}

DataComponentTableColumns.propTypes = {
    settingKey: PropTypes.any,
    data: PropTypes.array,
    onApply: PropTypes.func,
};

export default DataComponentTableColumns;
